import { getChartColor } from "./helper"
import { DatasetType, datasetPropType, scaleType } from "./types"

export const dynamicDatasets = (
  charts: datasetPropType,
  noOfCharts: number,
) => {
  if (noOfCharts === 0) {
    return
  }

  const newDataset: DatasetType = {
    scales: {},
    chartName: charts.chartName,
    data: {
      labels: [],
      datasets: [],
    },
  }

  newDataset.data.labels = charts.labels
  newDataset.chartName = charts.chartName

  const axes: any[] = []

  charts.datasets.forEach((data, i) => {
    const color = getChartColor()
    const datasetNew: any = {}
    datasetNew.label = data.label
    datasetNew.data = data.data
    datasetNew.backgroundColor = color
    datasetNew.borderColor = color
    datasetNew.type = data.type
    datasetNew.order = data.type === "line" ? 0 : 1
    datasetNew.yAxisID = data.data_type
    !axes.includes(data.data_type) && axes.unshift(data.data_type)

    newDataset.data.datasets.push(datasetNew)
  })

  const scale: scaleType = {
    isMultiAxis: false,
    axes: [],
  }

  if (axes.length > 1) {
    scale.isMultiAxis = true
  }

  axes.forEach((ax) => {
    const newAxis: {
      id: string
      type?: string
      position?: string
      axisUnit?: string
      offset?: boolean
      stackWeight?: number
      [key: string]: any
      label?: {
        display?: boolean
        text?: string
        position?: string
        color?: string
        align?: string
      }
    } = {
      id: "",
    }

    newAxis.id = ax
    newAxis.position = "left"
    newAxis.axisUnit = ax
    newAxis.label = newAxis.label || {}
    newAxis.label.display = ax === "%" ? true : false
    newAxis.offset = ax === "$" ? true : false
    // newAxis.label.text = ax === "%" ? "Month Actual" : ""
    newAxis.stackWeight = ax === "%" ? 1 : 2
    scale.axes.push(newAxis)
  })

  newDataset.scales = scale
  return newDataset
}
